@if (vms$ | async; as vm) {
    <ms-option-group-list
        [event]="vm.eventModel"
        [optionGroups]="vm.preparedOptionGoups | slice: 0 : limit"
        [tracking]="tracking"
        [trackingModuleType]="trackingModuleType"
        [optionsLimitOverride]="pod.optionsBeforeShowMore"
        [thresholds]="thresholds"
        [hideMarketHeader]="hideMarketHeader"
        [appendTooltipToWidgetSlot]="true" />
    @if (contentRendered && pod.marketsBeforeShowMore && limit < vm.preparedOptionGoups.length) {
        <div class="show-more-less-button" [ngClass]="{ expanded: limit >= vm.preparedOptionGoups.length }" (click)="showMarkets()">
            {{ sitecore.event.ShowMore }}
            <vn-icon class="icon-alignment" name="theme-down" size="12"></vn-icon>
        </div>
    }
    @if (contentRendered && limit >= vm.preparedOptionGoups.length && pod.showAllWagersLink) {
        <div class="all-markets-link">
            <ms-item [href]="link.url" [tracking]="undefined" (itemClicked)="trackBottomLink()"
                ><span item-title [innerHtml]="link.text! | msTrust: 'html'"></span>
            </ms-item>
        </div>
    }
}
